<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.temaId"
    item-text="nome"
    item-name="nome"
    item-value="temaId"
    :items="temas.filter((item) => item.nome !== 'Cidade Empreendedora')"
    label="Temas"
    hide-details="auto"
    solo
    placeholder="Temas"
    v-on:change="$emit('teste')"
    :clearable="true"
  >
    <template slot="no-data"> Nenhum Temas retornado </template>
  </v-select>
</template>

<script>
import { temaAPI } from "../../tema/API/temaAPI";

export default {
  name: "ComboboxTemas",
  props: ["filter"],
  mounted() {
    this.loadTemas();
  },
  methods: {
    loadTemas() {
      temaAPI
        .list()
        .then((resp) => {
          this.temas = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      temas: [],
    };
  },
};
</script>
